import clienteHttp from "./ClienteHttps";

/**
 * Obtiene los turnos disponibles con filtros
 * Si el usuario está logueado, envía su ID para calcular cobertura
 * Si no está logueado, no envía header y devuelve turnos sin cobertura
 */
export async function obtenerTurnosDisponibles(usuarioId, filtros = {}) {
    try {
        const config = {
            params: filtros,
            headers: {
                'Content-Type': 'application/json',
            },
        };

        // Solo enviar usuario-id si existe
        if (usuarioId) {
            config.headers['usuario-id'] = usuarioId;
        }

        const response = await clienteHttp.get('/turnos/disponibles', config);
        return response.data;
    } catch (error) {
        console.error('Error al obtener turnos disponibles:', error);
        const mensaje = error.response?.data?.error || 'Error al obtener turnos disponibles';
        throw new Error(mensaje);
    }
}

export async function obtenerTurnosDelMedico(medicoId, filtros = {}) {
    try {
        const response = await clienteHttp.get(`/turnos/medico/${medicoId}`, {
            params: filtros,
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener turnos del médico:', error);
        const mensaje = error.response?.data?.error || 'Error al obtener turnos del médico';
        throw new Error(mensaje);
    }
}